
// import { createElement } from '../../utils/constant';
// import $ from 'jquery';
// import React from "react";
// import Toast from '../Toast';
import _ from 'lodash';
const supportVersion = '1.1.5';
const pathMap =
{
  'netcar/index': '跳转打车',
  'openTab?tab=home': '跳转首页',
  'openTab?tab=video': '跳转娱乐',
  'openTab?tab=travel': '跳转行程',
  'openTab?tab=mine': '跳转我的'
}


const doNothing = () => {

};
function trackClick(trackBody) {
  const PNAME = `${window.location.protocol}//${window.location.host}${window.location.pathname !== '/' ? window.location.pathname : ''}`;
  const body = {
    actId: PNAME,
    ...trackBody
  }
  window.CRGTA && window.CRGTA.Event.trackClick({
    EventID: 'p_exit_common_2', // (必填)事件ID，查看埋点对照表
    Body: body
  })
}

function throttle(func, delay) {
  var timer = null;
  return function () {
    var context = this;
    var args = arguments;
    if (!timer) {
      func.apply(context, args);
      timer = setTimeout(function () {
        timer = null;
      }, delay);
    }
  }
}

function openView(params) {
  // console.log('onclick params', params);
  const { cid, vid } = params;
  // console.log('onclick', cid, vid);
  const trackBody = {
    cid,
    vid,
    path: '打开视频详情'
  }
  // console.log('打开详情', trackBody)
  trackClick(trackBody);
  if (!_.isNil(cid) && !_.isNil(vid)) {
    window.crgt && window.crgt.router.openView({
      path: 'video/detail',
      params: {
        vid, cid
      }
    });
  }

}

//
function openNativeView(params = {}) {
  // console.log('opennative view')
  const { nativePage } = params;
  const trackBody = {
    cid: 0,
    vid: 0,
    path: pathMap[`${nativePage}`]
  }
  // console.log( trackBody)
  const path = nativePage === 'netcar/index' ? 'netcar/index' : 'openTab';
  const paramBody = nativePage === 'netcar/index' ? {} : { tap: `${nativePage.split('=')[1]}` }
  // console.log(path, paramBody, trackBody)
  trackClick(trackBody);
  window.crgt && window.crgt.router.openView({
    path,
    params: paramBody
  });

}

function openDownload(params = {}) {
  //  https://static.ccrgt.com/download/?start_download=true&chid=12066
  let searchParams = window.location.href.split('&')[1];
  searchParams = _.isNil(searchParams) ? '' : searchParams;
  const trackBody = {
    cid: 0,
    vid: 0,
    path: '跳转下载页'
  }
  // console.log(searchParams, trackBody)
  trackClick(trackBody);
  const downloadUrl = `https://static.ccrgt.com/download/?start_download=true&${searchParams}`
  window.location.href = downloadUrl;
}

function compare() {
  const ua = (typeof navigator !== 'undefined') ? navigator.userAgent : '';
  const REGEXP_CRGT = /com.crgt.ilife\/([\d.]+)/i;
  if (typeof window !== 'undefined') {
    if (REGEXP_CRGT.test(ua) || (window.crgt && window.crgt.isCRGT)) {
      return window.crgt.compare(supportVersion);
    }
  }

}

function getNetworkType() {
  return new Promise((resolve, reject) => {
    window.crgt && window.crgt.device.getNetworkType().then(function (res) {
      if (res && res.code === 0 && res.data) {
        resolve(res.data.type)
      }
    }).catch((err) => {
      reject(err)
    })
  })

}

function openUrl(params) {
  // console.log('onclick params', params);
  const { url, target } = params;
  const trackBody = {
    cid: 0,
    vid: 0,
    path: url
  }
  // console.log('跳转url', trackBody)
  trackClick(trackBody);
  // console.log('onclick', url, target);
  if (!(_.isEmpty(url))) {
    window.crgt && window.crgt.router.openUrl({
      url,
      target
    });
  }

}

// const toast = function (options = {}) {
//   console.log('toast', Toast);
//   const { text, title } = options;
//   // const toast = new Toast();
//   const toast = React.createElement('Toast', { text, title }, null);
//   console.log(toast)
//   $('body').append(toast);
// }

export default {
  doNothing: throttle(doNothing, 2000),
  openView: throttle(openView, 2000),
  openNativeView: throttle(openNativeView, 2000),
  openDownload: throttle(openDownload, 2000),
  openUrl: openUrl,
  compare: compare,
  getNetworkType: getNetworkType,
}